export const GROUP_BY_PRICE = 'GROUP_BY_PRICE';
export const GROUP_BY_SCHEDULE = 'GROUP_BY_SCHEDULE';

const SWITCHER_PRICE = {
    id: GROUP_BY_PRICE,
    content: 'Group by Price',
    tooltip: 'Airline results grouped by price',
};
const SWITCHER_SCHEDULE = {
    id: GROUP_BY_SCHEDULE,
    content: 'Expand Alternatives',
    tooltip: 'Departure time alternatives are expanded in price order',
};
export default function FlightResultsController(
    $scope,
    $timeout,
    flightsFactory,
    flightsService,
    rangeSliderService,
    flightResultsSortTypes,
) {
    'ngInject';

    const vm = this;

    Object.assign(this, {
        $onInit,
        flights: flightsFactory.getFlights(),
        searchParameters: flightsFactory.params,
        switcherElements: [SWITCHER_PRICE, SWITCHER_SCHEDULE],
        composeCompanyLogoUrl: flightsService.getFlightSupplierLogo,
        groupFlights,
        areFlightsAvailable,
        onGroupByPriceChange,
        onSortTypeChange,
    });

    function $onInit() {
        initializeFlightGrouping();
    }

    $scope.areFiltersVisible = false;
    $scope.filtersChange = {
        changed: false,
    };
    $scope.toggleFilters = toggleFilters;
    $scope.IsRailSearchAvailable = vm.flights.IsRailSearchAvailable;
    $scope.RailSearchId = vm.flights.RailSearchId;

    function initializeFlightGrouping() {
        vm.groupByPrice = true;
        vm.sortByItems = [
            flightResultsSortTypes.CHEAPEST,
            flightResultsSortTypes.QUICKEST,
            flightResultsSortTypes.EARLIEST,
            flightResultsSortTypes.GREENEST,
        ];
        vm.sortByType = flightResultsSortTypes.CHEAPEST;
        vm.searchParameters.GroupByPrice = vm.groupByPrice;
        vm.searchParameters.SortType = vm.sortByType.value;
    }

    function onGroupByPriceChange(value) {
        if (value) {
            vm.sortByType = flightResultsSortTypes.CHEAPEST;
        }
        vm.groupByPrice = value;
        groupFlights();
    }

    function onSortTypeChange(value) {
        if (value !== flightResultsSortTypes.CHEAPEST) {
            vm.groupByPrice = false;
        }
        vm.sortByType = value;
        groupFlights();
    }

    function areFlightsAvailable() {
        return vm.flights.Total > 0;
    }

    function toggleFilters() {
        $scope.areFiltersVisible = !$scope.areFiltersVisible;
        rangeSliderService.forceRenderSlider();
    }

    function groupFlights() {
        vm.searchParameters.GroupByPrice = vm.groupByPrice;
        vm.searchParameters.SortType = vm.sortByType.value;
        flightsFactory.applyFilters(vm.searchParameters.Filters);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/flights/controllers/FlightResultsCtrl.js